import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '@ds';
import infoCircle from '@icons/info.svg';
import { ButtonSize, ButtonStyle } from '@ds/elements/Button/Button.types';
import styles from './PendingConfirmationBanner.module.scss';

const PendingConfirmationBanner: React.FC = () => {
  const navigate = useNavigate();

  const handleConfirmAddress = () => {
    navigate('/mailing-address-confirmation');
  };

  return (
    <div className={styles.bannerContainer}>
        <div className={styles.banner}>
            <div className={styles.iconAndText}>
            <img src={infoCircle} className={styles.icon}/>
            <div className={styles.textContainer}>
                <p className={styles.description}>
                We need you to confirm or update your mailing address.
                </p>
            </div>
            </div>
            <Button
                onClick={handleConfirmAddress}
                styleType={ButtonStyle.secondary}
                size={ButtonSize.medium}
                className={styles.confirmButton}
            >
            View Mailing Address
            </Button>
        </div>
    </div>
  );
};

export default PendingConfirmationBanner;